import { useKeycloak } from '@react-keycloak/web';
export default function useHasRole(realmAndResourceRoles) {
    const { keycloak } = useKeycloak();
    const hasResourceRole = (resourceRoles) => {
        var _a;
        return (_a = Object.entries(resourceRoles).some(([resource, role]) => testMaybeArray(role, (role) => keycloak.hasResourceRole(role, resource)))) !== null && _a !== void 0 ? _a : false;
    };
    const toResourceRoles = (roles) => keycloak.clientId ? { [keycloak.clientId]: roles } : {};
    const hasResource = (resource) => resource
        ? hasResourceRole(typeof resource === 'string'
            ? toResourceRoles([resource])
            : Array.isArray(resource)
                ? toResourceRoles(resource)
                : resource)
        : false;
    const testRealmAndResourceRoles = ({ realm, resource, }) => (realm
        ? testMaybeArray(realm, (role) => keycloak.hasRealmRole(role))
        : false) || hasResource(resource);
    return keycloak.authenticated && realmAndResourceRoles
        ? testRealmAndResourceRoles(typeof realmAndResourceRoles === 'string'
            ? toRealmAndResourceRoles([realmAndResourceRoles])
            : Array.isArray(realmAndResourceRoles)
                ? toRealmAndResourceRoles(realmAndResourceRoles)
                : realmAndResourceRoles)
        : false;
}
const toRealmAndResourceRoles = (role) => ({
    realm: role,
    resource: role,
});
const testMaybeArray = (role, test) => Array.isArray(role) ? role.some(test) : test(role);
//# sourceMappingURL=useHasRole.js.map